import { Fragment, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  /**
   * Los hechos del producto, en orden de importancia. Los vacíos se descartan:
   * el que arma la lista puede escribir `cond && dato` sin dejar separadores
   * colgando.
   */
  items: ReactNode[];
}

/**
 * La línea de metadata: los hechos como TEXTO QUIETO separado por puntos, no
 * como una fila de chips. Cuando todo es un chip —capacidades, categorías,
 * horas, avisos— nada se lee, y el chip deja de significar "prestá atención".
 *
 * Los estados operacionales sí van en chip, pero eso es `StatusFlag`.
 */
export function MetaLine({ items }: Props) {
  const visible = items.filter(Boolean);
  if (visible.length === 0) return null;

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      // Interlineado apretado: es una línea de hechos cortos, y el aire de
      // `body2` (1,43) le agregaba tres píxeles a cada card de la lista.
      sx={{ fontSize: 12.5, lineHeight: 1.35 }}
    >
      {visible.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <Box component="span" color="text.disabled" sx={{ mx: 0.5 }}>
              ·
            </Box>
          )}
          {item}
        </Fragment>
      ))}
    </Typography>
  );
}
